import { combineReducers } from 'redux';
import NotificationsReducer from './Notifications';

// reducers
const appReducer = combineReducers({
  //   routing: routerReducer,
  //   form: formReducer,
  notifications: NotificationsReducer,
});

export default appReducer;
